import { Button, Drawer, notification, Row, Space, Spin, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Select1, TextArea1 } from '../../../Components/FormComponents/InputFields';
import { MdInbox } from 'react-icons/md';
import { download } from '../../../Services/GeneralFunctions';
import { LoadingOutlined } from '@ant-design/icons'

const { Dragger } = Upload;

 export default function EditTicket ( { open, onClose, getEmployeesData } ) {

    const { control, formState: {errors}, handleSubmit, reset } = useForm();
    const [api, contextHolder] = notification.useNotification();

    const [ fileList, setFileList ] = useState([]);
    const [ toggleDisable, setToggleDisable ] = useState(false); 

    const [ submitLoader, setSubmitLoader ] = useState(false);


    const onSubmit = async (val) => {
      // try {
      //   const data = await AddEmployeeApi(val);

      //   if (data.data.success) {
      //     api.success({
      //       message: data.data.message,
      //       placement: 'top'
      //     });
      //     getEmployeesData();
      //     onClose();
      //   }
      //   else {
      //     api.error({
      //       message: data.data.message,
      //       placement: 'top'
      //     });
      //   }
      // }
      // catch (err) {
      //   api.error({
      //     message: err.message,
      //     placement: 'top'
      //   });
      // }
    }

    const handleExcelSubmit = async () => {
      // let formData = new FormData();
      // formData.append('employee_list', fileList[0]);

      // try {
      //   const data = await ExcelUploadApi(formData);
      //   console.log(data);
      //   if ( data.statusText === 'OK' ) {
      //     api.success({
      //       message: 'File is Submitted Successfully!',
      //       description: 'Please Check the Downloaded Result File for Status.',
      //       placement: 'top'
      //     });
      //     download(new Blob([data.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}), 'result.xlsx');
      //   }
      // }
      // catch (err) {
      //   api.error({
      //     message: err.message,
      //     placement: 'top'
      //   });
      // }
      
      // onClose();
    }

    const onPdfUpload = (temp, val) => {
      setToggleDisable(true);

      if (val[0].type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || val[0].type==='application/vnd.ms-excel') {
        setFileList(val);
        return false;

      }
      else {
        return Upload.LIST_IGNORE;
      }
    }

    useEffect(() => {
      reset();
      setFileList([]);
      setToggleDisable(false);
    }, [onClose])

  return (
    <>
      { contextHolder }
      <Drawer
        title="Raise a Ticket"
        onClose={onClose}
        open={open}
        contentWrapperStyle={{width: '100vw'}}
        bodyStyle={{
          paddingBottom: 80,
          
        }}
        footer={
          <Space size='middle'>
            <Button size='large' onClick={onClose}>Cancel</Button>
            <Button size='large' onClick={handleSubmit(onSubmit)} type="primary">
              { submitLoader && <Spin className='mr-2 mb-2' size='default' indicator={<LoadingOutlined className='text-light' />} spinning={true}/>}
              Submit
            </Button>
          </Space>
        }
        footerStyle={{textAlign: 'right'}}
      >
            <Row>
                <Select1 control={control} errors={errors} validations={ { required: true } } id='typeOfIssue' name='Type of Issue' />
                <TextArea1 control={control} errors={errors} validations={ { required: true } } id='remarks' name='Remarks' />

                <Controller
                  name='policyPdf'
                  control={control}
                  defaultValue={[]}
                  rules={{ required: true }}
                  render={({ field }) => 
                    <Dragger 
                      className='w-100 mx-3 mt-4' beforeUpload={(temp, val) => onPdfUpload(val, field.onChange)} 
                      listType='picture'
                      accept='application/pdf'
                      maxCount={1}
                      fileList={field.value}
                      onRemove={() => field.onChange([])}
                    >
                      <p className="ant-upload-drag-icon">
                        <MdInbox className='fs-1 text-info' />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">
                        Support for a single PDF file.
                      </p>
                    </Dragger>
                  }
                />
                {errors && errors.policyPdf?.type === 'required' && <span className='mx-3 text-danger' style={{ fontSize: '13px', bottom: '-20px'}} role="alert">Please Select a File.</span>}

            </Row>
      </Drawer>
    </>
  );
};